import React, {Component} from "react"
import TimeTick from './components/UI/TimeTick'
import Aux from 'react-aux'
import store from "./store/index";

var textColorForTd={
  color: 'green',
}

class ColoredTD extends Component{

   timeTickTdStyle = {
    paddingLeft: 0
   }

   getStep = price => {
     if(price < 2) return 0.01
     else if(price < 3) return 0.02
     else if(price < 4) return 0.05
     else if(price < 6) return 0.1
     else if (price < 10) return 0.2
     else if (price < 20) return 0.5
     else if (price < 30) return 1
     else if (price < 50) return 2
     else if (price < 100) return 5
     else if (price < 1000) return 10
   }

   calculateTicks = (currentPrice, priceAtTime) => {
     let low = 0
     let high = 0
     if(currentPrice !== null && priceAtTime !== null) {
       low = currentPrice <= priceAtTime ? currentPrice : priceAtTime
       high = currentPrice <= priceAtTime ? priceAtTime : currentPrice
       let ticks = 0
       let step = this.getStep(low)
       while(low < high) {
         ticks++
         low = low + step
         step = this.getStep(low)
       }
       return ticks
     }
     return ""
   }
   
  render(){

    const tickValue = this.calculateTicks(this.props.currentPrice, this.props.priceAtTime)

    var percentageTdStyle = {

    }

    if(this.props.displayTicks) {
      percentageTdStyle = {
        paddingRight: 0
      }
    }

    var value = this.props.value
    var marketMovement = (this.props.displayResult === 'Market Movement')
    if(marketMovement){
      value = (100/this.props.currentPrice - 100/this.props.priceAtTime ).toFixed(2);
      if(!Number.isNaN(value))
        value = value + "%";
      }

    if(this.props.value.startsWith("-")){
      var textColorForTd={
        color: 'red',
        display: 'flex'
      }
      
      var combinedTdStyle = {
        ...textColorForTd,
        ...percentageTdStyle
      }

      const timeTickTd = this.props.displayTicks ? <td style={this.timeTickTdStyle}><TimeTick value={tickValue} /></td> : null

      return(
        <Aux>
        <td style={combinedTdStyle}>{value}
        </td>
        {timeTickTd}
        </Aux>
      )
    }else if(this.props.value=='n/a'){
      var textColorForTd={
        color: 'black',
        display: 'flex'
      }

      var combinedTdStyle = {
        ...textColorForTd,
        ...percentageTdStyle
      }

      const timeTickTd = this.props.displayTicks ? <td style={this.timeTickTdStyle}><TimeTick value={tickValue}/></td> : null
      return(
        <Aux>
        <td style={combinedTdStyle}>{value}
        </td>
        {timeTickTd}
        </Aux>
      )
    }
    else{
      value = "+" + value
      var textColorForTd={
        color: 'green',
        display: 'flex'
      }

      var combinedTdStyle = {
        ...textColorForTd,
        ...percentageTdStyle
      }
      
      const timeTickTd = this.props.displayTicks ? <td style={this.timeTickTdStyle}><TimeTick value={tickValue}/></td> : null

      return(
        <Aux>
        <td style={combinedTdStyle}>{value}</td>
        {timeTickTd}
        </Aux>
      )
    }

  }
}
export default ColoredTD
